export function formatPrenom( prenom ) {
    if ( !prenom ) {
        return "";
    }

    return prenom
        .split( /[-\s]/ )
        .map( ( word ) => word.charAt( 0 ).toUpperCase() + word.slice( 1 ).toLowerCase() )
        .join( prenom.includes( "-" ) ? "-" : " " );
}
